import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { HiOutlineChatBubbleLeftRight } from 'react-icons/hi2';

interface ITasksEmptyStateProps {
  onCreate: () => void;
}

const TasksEmptyState = ({ onCreate }: ITasksEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        position: 'relative',
        overflow: 'hidden',
        minHeight: '400px',
      }}
    >
      {/* Concentric circles background */}
      <Box
        sx={{
          position: 'absolute',
          width: '480px',
          height: '480px',
          borderRadius: '50%',
          border: '1px solid #EAEDF1',
          opacity: 0.6,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '360px',
          height: '360px',
          borderRadius: '50%',
          border: '1px solid #EAEDF1',
          opacity: 0.6,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '240px',
          height: '240px',
          borderRadius: '50%',
          border: '1px solid #EAEDF1',
          opacity: 0.6,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          border: '1px solid #EAEDF1',
          opacity: 0.6,
        }}
      />

      {/* Icon */}
      <Box
        sx={{
          width: '48px',
          height: '48px',
          borderRadius: '10px',
          border: '1px solid #EEEBFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fff',
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          zIndex: 1,
          mb: 2,
        }}
      >
        <HiOutlineChatBubbleLeftRight size={24} color="#435363" />
      </Box>

      {/* Text */}
      <Typography
        sx={{
          fontFamily: 'Tajawal, sans-serif',
          fontWeight: 800,
          fontSize: '16px',
          color: '#121926',
          textAlign: 'center',
          zIndex: 1,
          mb: 3,
        }}
      >
        {t('Automation.noTasksYet')}
      </Typography>

      {/* CTA Button */}
      <Button
        variant="contained"
        onClick={onCreate}
        sx={{
          backgroundColor: '#5B3FFF',
          borderRadius: '12px',
          fontFamily: 'Tajawal, sans-serif',
          fontSize: '14px',
          fontWeight: 700,
          textTransform: 'none',
          px: '97px',
          py: '16px',
          zIndex: 1,
          '&:hover': {
            backgroundColor: '#4930CC',
          },
        }}
      >
        {t('Automation.createNewTask')}
      </Button>
    </Box>
  );
};

export default TasksEmptyState;
